export enum ShaderName {
	VERTEX = 'vertex',
	FRAGMENT = 'fragment',
	LEAVES_FROM_NODES_SHADER = 'leaves_from_nodes_shader',
}
